import { UserRepository } from "../../api/repo/UserRepository";

export class DisableMFAForUserPresenter {
    userApiRepo = new UserRepository;

    disableMFAUserAccount(args) {
        this.userApiRepo.disableMFAUserAccount(args.searchValue).then(response => {
            const {success, data, error} = response;
            if (success) {
                args.onSuccess && args.onSuccess(data)
            } else {
                args.onError && args.onError(error)
            }
        });
    }

}